import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { editEntityInfo } from '../../../actions/entity-designer.actions';
import { getEntityProp } from '../../../selectors/entity-designer.selectors';

const useStyles = makeStyles({
  checkboxWrapper: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
  },
});

const CheckboxControl = ({ label, prop, disabled }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const currentValue = useSelector((state) => getEntityProp(state, { prop }));

  const handleChange = ({ target: { checked } }) => {
    dispatch(editEntityInfo({ prop, value: checked }));
  };

  return (
    <div className={classes.checkboxWrapper}>
      <div className={classes.rowLabel}>
        <Typography>{translateString(label)}</Typography>
      </div>
      <div style={{ marginLeft: 25 }} className={classes.rowColumn}>
        <Checkbox
          checked={currentValue}
          disabled={disabled}
          onChange={handleChange}
          aria-label={translateString(label)}
        />
      </div>
    </div>
  );
};

export default CheckboxControl;
